import {useState} from "react";
import {platformAPI} from "../../../api/axiosConfig";
import {PaginatedResponseV2} from "../../../types/PaginatedResponse";
import {Hotline} from "../typedefs";
import {useQuery} from "react-query";
import useDebouncer from "../../../hooks/debouncer";

export async function fetchHotlines(page: number, limit: number, search: string, clientID: string) {

    const res = await platformAPI.get<PaginatedResponseV2<Hotline>>("api/hotlines", {
        params: {
            page,
            limit,
            search,
            clientID,
        }
    })

    return res.data

}


export function useGetHotlines(clientID: string|null, initialSearch = "", initialPage = 1) {
    const [page, setPage] = useState(initialPage);
    const [limit, setLimit] = useState(20);
    const [search, setSearch] = useState(initialSearch);

    const debouncedSearch = useDebouncer(search, 300);


    const {data, isLoading, error, refetch} = useQuery(
        ["hotline", page, limit, debouncedSearch],
        () => fetchHotlines(page, limit, debouncedSearch, clientID!),
        {
            enabled: !!clientID,
            cacheTime: 0,
            refetchOnMount: true,
        }
    );

    return {
        page, setPage,
        limit, setLimit,
        search, setSearch,
        data,
        isLoading,
        error,
        refetch
    }


}